/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';
import { IldsFooterProps } from '../lds-footer.data';

export const FooterImageLink: React.FC<IldsFooterProps> = ({ Links }) => {
    // const footerImageLink = Links ? Links.footerImageLink : '';
    const footerImage = Links ? Links.image : '';

    return (
        <div className='footerImageLink'>
            <img
                style={{
                    width: '116.77px',
                    height: 'auto'
                }}
                src={footerImage && footerImage.src ? footerImage.src : footerImage}
                alt={footerImage && footerImage.altText ? footerImage.altText : 'FooterImage'}
            />
        </div>
    );
};
